module.exports = __webpack_public_path__ + "static/media/socialResponsibilityIcon.65bc1dcb.svg";